import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function UsersAction(props) {
  const { onClickDelete, selectedUsers } = props;

  return (
    <div
      data-test="user-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Add User">
        <Link
          type="button"
          className="w-[50px] relative cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          to="/users/new"
        >
          <img
            src="/assets/images/icons/upload_icon.svg"
            alt="upload icon"
            className="w-[50px] h-[50px] cursor-pointer"
          />
        </Link>
      </ToolTipIcon>
      {selectedUsers.length > 0 && (
        <ToolTipIcon toolText={pluralize('Delete User', selectedUsers.length)}>
          <button
            type="button"
            onClick={onClickDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

UsersAction.propTypes = {
  selectedUsers: PropTypes.array,
  onClickDelete: PropTypes.func,
};
const mapDispatchToProps = {};
const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersAction);
